import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cwt-ion-component-preloader',
  styles: [`
    :host {
        display: none;
        user-select: none;
        pointer-events: none;
    }
  `],
  template: `
    <!-- Add components to preload here !-->
    <ion-alert></ion-alert>
    <ion-modal></ion-modal>
    <ion-select></ion-select>
    <ion-toast></ion-toast>
    <ion-card></ion-card>
    <ion-button></ion-button>
    <ion-text></ion-text>
    <ion-grid></ion-grid>
    <ion-datetime></ion-datetime>
    <ion-input></ion-input>
    <ion-label></ion-label>
    <ion-skeleton-text></ion-skeleton-text>
    <ion-spinner></ion-spinner>
    <ion-toggle></ion-toggle>
    <ion-backdrop></ion-backdrop>
    <ion-ripple-effect></ion-ripple-effect>
    <ion-back-button></ion-back-button>
    <ion-icon></ion-icon>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IonComponentPreloaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
